import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Button, Col, Dropdown, Row, Space, Statistic } from 'antd';
import { DownOutlined, ShoppingCartOutlined, TabletOutlined } from '@ant-design/icons';
import useApiClient from '../../../hooks/api/useApiClient';
import usePermissions from '../../../hooks/auth/usePermissions';
import OrdersTable from '../../../components/orders/OrdersTable';

export const action_launch_orders_portal_app = 'launch_orders_portal_app';
export const action_create_dummy_order = 'create_dummy_order';

export default function OrdersView() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Sales:Orders' });

  const { OrdersManager, MagicLinksManager } = useApiClient();
  const { isAdmin, isMerchant } = usePermissions();

  const { company } = useSelector((state) => state.currentCompany);

  const [actionPending, setActionPending] = useState(false);
  const [ordersMeta, setOrdersMeta] = useState(null);

  const shouldShowMetrics = isAdmin || isMerchant;

  async function createDummyOrder() {
    setActionPending(true);
    const { success } = await OrdersManager.createDummyOrder();
    setActionPending(false);

    if (!success) {
      return toast.error(t('toasts.failed_to_create_dummy_order'));
    }

    toast.success(t('toasts.dummy_order_created'));
  }

  async function launchOrdersPortal() {
    setActionPending(true);
    const { success, data: responseData } = await MagicLinksManager.create({
      app: 'staff',
    });
    setActionPending(false);

    if (!success) {
      return toast.error(t('toasts.failed_to_launch_orders_portal_app'));
    }

    return window.open(responseData.url);
  }

  const dropdownItems = [
    {
      key: action_launch_orders_portal_app,
      label: t(`buttons.${action_launch_orders_portal_app}`),
      icon: <TabletOutlined />,
    },
    { type: 'divider' },
    {
      key: action_create_dummy_order,
      label: t(`buttons.${action_create_dummy_order}`),
      icon: <ShoppingCartOutlined />,
    },
  ];

  return (
    <>
      <div className="flex justify-between mb-4">
        <h2>{t('title')}</h2>
        {company?.id && (
          <Dropdown
            menu={{
              items: dropdownItems,
              onClick: (e) =>
                ({
                  [action_launch_orders_portal_app]: launchOrdersPortal,
                  [action_create_dummy_order]: createDummyOrder,
                })[e.key](),
            }}
            className="justify-end"
          >
            <Button loading={actionPending}>
              <Space>
                {t('buttons.actions')}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
        )}
      </div>
      {shouldShowMetrics && (
        <Row gutter={12}>
          <Col span={12} lg={6}>
            <Statistic title={t('metrics.total_orders')} value={ordersMeta?.total} />
          </Col>
        </Row>
      )}
      <div className="mt-4">
        <OrdersTable onMetaChange={setOrdersMeta} />
      </div>
    </>
  );
}
